import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController, Navbar } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';
import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-project',
  templateUrl: 'project.html',
  providers : [HttpClient, CustomToast]
})
export class ProjectPage {

	private modalCtrl : ModalController;
  private httpClient : HttpClient;
  private customToast : CustomToast;
  private events : Events;
  private alertCtrl : AlertController;

  private baseUrl;

  private image = {
    id : -1,
    filename : 'addimage.png'
  };

  private users;
  private researchers = [];
  private project = {
    id : -1,
    name_es : '',
    name_en : '',
    code : '',
    date_start : '',
    date_end : '',
    funding : '',
    budget : '',
    person_id : '-1',
    coip : '-1',
    text_es : '',
    text_en : '',
    image : '',
    participants : [],
    externalIp : '',
    externalParticipants : '',
    url: ''
  };

  @ViewChild(Navbar) navBar : Navbar;

  private participants = [];

  private selectedParticipants;
  private restOfParticipants;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events, customToast : CustomToast, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;

    var id = navParams.get('id');
    this.httpCallProject(id);
    this.httpCallParticipants(id);
    this.httpCallPeople();
  }
  
  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertCtrl.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.project.image = image.filename;
      }
    });
  }

  httpCallPeople(){
    this.httpClient.get('/users?max=10000', (error,data)=>{
      let allusers = data.json();
      this.researchers = allusers.filter(function(user){
        return user.person_type_id==5 || user.person_type_id==18 || user.person_type_id==19;
      }).sort((a,b)=>{
        if (a.name.localeCompare(b.name,'es') < 0)
        return -1;
        if (a.name.localeCompare(b.name,'es') > 0)
        return 1;
      return 0;
      });
      this.users = allusers.filter(function(user){
        return user.person_type_id==5 || user.person_type_id==6 || user.person_type_id==7 || user.person_type_id==8 ;
      }).sort((a,b)=>{
        if (a.name.localeCompare(b.name,'es') < 0)
        return -1;
        if (a.name.localeCompare(b.name,'es') > 0)
        return 1;
      return 0;
      });
    });
  }

  httpCallNotParticipants(participants : any){
    this.httpClient.get('/users?max=10000', (error,data)=>{
      let allusers = data.json();
      let myUsers = allusers.filter(function(user){
        return user.person_type_id==5 || user.person_type_id==6 || user.person_type_id==7 || user.person_type_id==8 ;
      }).sort((a,b)=>{
        if (a.name.localeCompare(b.name,'es') < 0)
        return -1;
        if (a.name.localeCompare(b.name,'es') > 0)
        return 1;
      return 0;
      });

      for(var i = 0; i < participants.length; i++){
        for(var j = 0; j < myUsers.length; j++ ){
          if(participants[i].id == myUsers[j].id){
            myUsers.splice(j,1);
          }
        }
      }

      this.restOfParticipants = myUsers;
    });
  }

  httpCallParticipants(id){
    this.httpClient.get('/projects/' + id + '/participants', (error,data)=>{
      if(!error){
        this.selectedParticipants = data.json();
        for(var i = 0; i<this.selectedParticipants.length; i++){
          this.participants.push(this.selectedParticipants[i].id);
        }
        this.httpCallNotParticipants(this.selectedParticipants);
      }
    });
  }

  httpCallProject(id){
    this.httpClient.get('/projects/'+id,(error,data)=>{
      if(!error){
        this.project = data.json();
        this.image.id = 1;
        if(this.project.image){
          this.image.filename = this.project.image;
        }
      }else{
        window.open('/#/page-not-found','_system');
      }
    });
  }

  onClickSave(){
    this.project.date_start = this.project.date_start.split('T')[0];
    this.project.date_end = this.project.date_end.split('T')[0];
    this.project.participants = this.participants;

    if(this.project.url && !this.project.url.includes('http')) this.project.url = 'http://' + this.project.url;
    
    this.saveProject();
  }

  private saveProject(){
    if(!this.project.date_start || !this.project.date_end){
      this.customToast.showMessage('Asegúrate de haber introducido todos los campos requeridos',2000);
    }else{
      this.httpClient.put('/projects/',this.project,(error,data)=>{
        if(!error){
          this.customToast.showMessage('Proyecto actualizado',2000);
          this.navCtrl.pop();
          this.events.publish('project:update');
        }
      }); 
    }
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de este proyecto',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/projects/'+this.project.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Proyecto eliminado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('project:delete');
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/projects/project/project.ts